import { configureStore } from '@reduxjs/toolkit';

// ROUTING KIT-QR SCREENS
import RouterSlice from '../slices/routerSlice';
// HANDLE USER INFORMATION
import UserSlice from '../slices/userSlice';
// HANDLE BANK INFORMATION
import BankSlice from '../slices/bankSlice';
// HANDLE TRANSACTION INFORMATION
import transactionSlice from '../slices/transactionSlice';
// HANDLE TRANSACTION INFORMATION
import StoreSlice from '../slices/storeSlice';

export default configureStore({
    reducer: {
        user: UserSlice,
        bank: BankSlice,
        router: RouterSlice,
        transaction: transactionSlice,
        store: StoreSlice
    }
})